import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/toast/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`A toast should be used to display a short lived alert at the bottom of the screen with a message, and optionally, a CTA.`}</p>
    <p><img parentName="p" {...{
        "src": "/a0b3a13dd67777f5c53d141ffb3447b6/toast.png",
        "alt": "toast"
      }}></img></p>
    <h2>{`Accessibility`}</h2>
    <p>{`The toast component supports dynamic type by default`}</p>
    <h2>{`Public API`}</h2>
    <p><inlineCode parentName="p">{`public var message: String`}</inlineCode>{` The message text to be displayed to the user`}</p>
    <p><inlineCode parentName="p">{`public var action: Toast.Action`}</inlineCode>{` The “action” to take on the toast. Includes link text, and a handler closure.`}</p>
    <p><inlineCode parentName="p">{`public var theme: Toast.Theme`}</inlineCode>{` A toast theme, which allows for customization of the background color, text color, icon, and icon color.`}</p>
    <p><inlineCode parentName="p">{`public let presentationDuration: TimeInterval`}</inlineCode>{` The duration for which to display the toast, defaults to 5 seconds.`}</p>
    <h2>{`Usage`}</h2>
    <p>{`You can construct a toast with various themes like`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let toast = Toast(message: "This is a message?", theme: Toast.Theme.alert(), action: Toast.Action(text: "Take Action", handler: {
 /* Do some action */
}))
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/6715879578121e9fa7b2db2f0cf68c4d/alert.png",
        "alt": "alert"
      }}></img></p>
    <p>{`You can customize the theme by overriding various properties`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let toast = Toast(message: "This is a message?", theme: Toast.Theme.success(Icon.contentActionsAddMedium), action: Toast.Action(text: "Take Action", handler: {}))
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/8c99152d34ea14b90d81c31c5e66eb13/custom.png",
        "alt": "custom"
      }}></img></p>
    <p>{`Once constructed, a toast can be displayed with animation using the showToast method.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import Thumbprint

/* ... */

public func display(_ toastWithText text: String, linkText: String, in view: UIView) {
     let toast = Toast(message: text, action: Toast.Action(text: linkText, handler: {
      /* Do some action */
     }))

     toast.showToast(animated: false, completion: nil)
     view.addSubview(toast)
     toast.snp.makeConstraints { make in
          make.leading.trailing.bottom.equalToSuperview()
     }

}
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      